const containerVariables = new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'containerBg',
    {
      var: 'components.bifrost.container.bg',
      cssVar: 'bifrost-container-bg',
    },
  ],
  [
    'containerBorder',
    {
      var: 'components.bifrost.container.border',
      cssVar: 'bifrost-container-border',
    },
  ],
  [
    'containerBorderRadius',
    {
      var: 'components.bifrost.container.borderRadius',
      cssVar: 'bifrost-container-border-radius',
    },
  ],
  [
    'containerElevation',
    {
      var: 'components.bifrost.container.elevation',
      cssVar: 'bifrost-container-elevation',
    },
  ],
  [
    'containerMaxWidth',
    {
      var: 'components.bifrost.container.maxWidth',
      cssVar: 'bifrost-container-max-width',
    },
  ],
]);

export default containerVariables;
